import { routeMap } from '../../routes';

export function translatePath(pathname, currentLang, targetLang) {
  // ukloni jezični prefiks iz patha
  const parts = pathname.split('/').filter(Boolean);
  const routeKey = Object.keys(routeMap).find((key) => routeMap[key][currentLang] === parts[1]);

  if (routeKey) {
    const newPath = routeMap[routeKey][targetLang];
    return `/${targetLang}/${newPath}`;
  }

  // fallback
  return `/${targetLang}`;
}